import React, { createContext, useContext, useState } from 'react'
import CustomSnackbar from '../modules/CustomSnackbar';
const CommonContext = createContext()

export const useCommon = () => {
    return useContext(CommonContext);
};

export const CommonProvider = ({ children }) => {
    let user = {
        accessToken: localStorage.getItem('accessToken'),
        userId: localStorage.getItem('userId'),
        userName: localStorage.getItem('userName'),
        role: localStorage.getItem('role')
    };
    const [currentUser, setCurrentUser] = useState(user);
    const [snackbar, setSnackbar] = useState({
        openSnackbar: false,
        message: '',
        severity: ''
    });

    const context = { snackbar, setSnackbar, currentUser, setCurrentUser }
    return (
        <CommonContext.Provider value={context}>
            {children}
            <CustomSnackbar
                openSnackbar={snackbar.openSnackbar}
                closeSnackbar={() => setSnackbar({
                    openSnackbar: false,
                    message: '',
                    severity: ''
                })}
                severity={snackbar.severity}
                message={snackbar.message}
            />
        </CommonContext.Provider>
    );
}